import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class PlantService {
    static getPlants(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`plants?filter=${qs}`, pageNumber));
    }
    static fetchPlant(oid) {
        return lastValueFrom(BaseService.get(`plants/${oid}`));
    }
    static savePlant(dto) {
        return lastValueFrom(BaseService.save(`plants`, dto));
    }
    static deletePlant(oid) {
        return lastValueFrom(BaseService.delete(`plants/${oid}`));
    }
    static searchPlantCombo(selfId, farmPlant, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`plants-search-dropdown/${selfId}/${farmPlant}?search=${qs}`));
    }
}
